import { getFullUrl } from 'hubspot-url-utils';
import BusinessUnitPickerSubmenuItem from './BusinessUnitPickerSubmenuItem';
import { getPortalId } from '../../utils/getPortalId';
import { useTranslation } from '../../hooks/useNavConfig';
import { StyledMenuPickerTopLink } from '../Menu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessUnitPickerSubmenu = ({
  businessUnits
}) => {
  const {
    t
  } = useTranslation();
  const portalId = getPortalId();
  const linkHref = `${getFullUrl('app')}/settings/${portalId}/business-units/`;
  return /*#__PURE__*/_jsxs("div", {
    id: 'manageBusinessUnits',
    children: [/*#__PURE__*/_jsx(StyledMenuPickerTopLink, {
      id: 'manageBusinessUnits-label',
      href: linkHref,
      "data-test-id": "nav-account-menu-business-unit-picker-submenu-top-link",
      "data-click-action": "Manage Business Units Selected",
      children: t('nav.tools.manageBusinessUnitsV2')
    }), businessUnits.map(businessUnit => /*#__PURE__*/_jsx(BusinessUnitPickerSubmenuItem, {
      businessUnit: businessUnit
    }, businessUnit.id))]
  });
};
export default BusinessUnitPickerSubmenu;